import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import axios from "../../../api/axiosService";
import FadeInSection from "../../../Components/FadeInSection";

// import required modules
import { EffectCoverflow } from "swiper/modules";

function Magazine(props) {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(1);
  const [width, setWidth] = useState(window.innerWidth);
  const swiperRef = useRef(null);
  const [depth, setDepth] = useState(300);
  const [spaceBetween, setSpaceBetween] = useState(200);
  const [magazines, setMagazines] = useState([]);

  const getMagazines = async () => {
    try {
      const response = await axios.get(`/api/magazine/list`);
      setMagazines(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const updateDepth = () => {
    const width = window.innerWidth;
    setWidth(width);

    if (width < 768) {
      setDepth(30);
      setSpaceBetween(30);
    } else if (width >= 768 && width < 1024) {
      setDepth(200);
      setSpaceBetween(100);
    } else if (width >= 1024 && width < 1280) {
      setDepth(250);
      setSpaceBetween(150);
    } else {
      setDepth(300);
      setSpaceBetween(200);
    }
  };

  useEffect(() => {
    getMagazines();
  }, []);

  useEffect(() => {
    updateDepth();
    if (swiperRef.current) {
      swiperRef.current.slideTo(1);
    }
  }, [magazines]);

  return (
    <div className="magazine-ssg w-100">
      {/* Header section */}
      <FadeInSection direction="down">
        <div className="magazine-header global-header-block-2">
          <div className="magazine-text normal-text">{t("NEWS")}</div>
          <h1 className="magazine-title global-title-margin title-1">
            {" "}
            {t("SSL_MAGAZINE")}
          </h1>
        </div>
      </FadeInSection>

      <div className="flex w-full gap-[40px] mb-[50px] sticky top-[70px] bg-white justify-center z-10">
        {magazines.map((magazine, index) => (
          <div
            key={index}
            className="mb-[10px] md:mb-[0px] text-center pt-[20px] pb-[20px]"
          >
            <button
              data-index="index"
              className={`year-tab pb-[10px] normal-text ${
                index === activeIndex ? "active" : ""
              }`}
              onClick={() => {
                setActiveIndex(index);
                swiperRef.current.slideTo(index);
              }}
            >
              {magazine.year}
            </button>
          </div>
        ))}
      </div>

      <div className="w-full md:max-w-[1920px]">
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          spaceBetween={spaceBetween}
          slidesPerView={width < 768 ? 1.5 : 3}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: depth,
            modifier: 1,
            slideShadows: false,
          }}
          pagination={false}
          modules={[EffectCoverflow]}
          className="mySwiper"
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
        >
          {magazines.map((magazine, index) => (
            <SwiperSlide key={index}>
              <div
                className={`transition-all duration-300 ease-in-out flex flex-col items-center`}
                onClick={() => window.open(magazine.url, "_blank")}
              >
                <img
                  src={magazine.image}
                  alt={magazine.title}
                  className="rounded-lg shadow-lg"
                />
                <p className="mt-[10px] md:mt-[30px] text-center">
                  {magazine.title}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default Magazine;
